const normalizeBase64 = (base64: string): string => {
  if (base64) {
    let normalized = base64.replace(/\s+/g, '');
    normalized = normalized.replace(/=*$/, '');

    return normalized;
  }

  return null;
};

const compareBase64 = (base64_1: string, base64_2: string): boolean => {
  return normalizeBase64(base64_1) === normalizeBase64(base64_2);
};

export const Base64Util = {
  compareBase64,
  normalizeBase64,
};
